//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VFormRender from '@/components/form-render/index';
import Clipboard from 'clipboard';
import { deepClone, copyToClipboard, generateId, getQueryParam, traverseAllWidgets, addWindowResizeHandler } from '@/utils/util';
import i18n from '@/utils/i18n';
// import { saveAs } from 'file-saver'
// import SvgIcon from '@/components/svg-icon'
import CodeEditor from '@/components/code-editor/index';
import { formCrudSave, formInfo as _formInfo } from '@/api/form';
export default {
  name: 'ToolbarPanel',
  mixins: [i18n],
  components: {
    VFormRender: VFormRender,
    Clipboard: Clipboard,
    // SvgIcon,
    CodeEditor: CodeEditor
  },
  props: {
    designer: Object,
    globalDsv: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  inject: ['getDesignerConfig'],
  data: function data() {
    return {
      designerConfig: this.getDesignerConfig(),
      toolbarWidth: 220,
      showPreviewDialogFlag: false,
      showImportJsonDialogFlag: false,
      showExportJsonDialogFlag: false,
      showExportCodeDialogFlag: false,
      showFormDataDialogFlag: false,
      showExportSFCDialogFlag: false,
      showNodeTreeDrawerFlag: false,
      nodeTreeData: [],
      testFunc: '',
      importTemplate: {
        formConfig: {},
        widgetList: []
      },
      jsonContent: '',
      jsonRawContent: '',
      formDataJson: '',
      formDataRawJson: '',
      vueCode: '',
      htmlCode: '',
      sfcCode: '',
      sfcCodeV3: '',
      activeCodeTab: 'vue',
      activeSFCTab: 'vue2',
      testFormData: {
        // 'userName': '666888',
        // 'productItems': [
        //   {'pName': 'iPhone12', 'pNum': 10},
        //   {'pName': 'P50', 'pNum': 16},
        // ]

        select62173: 2
      },
      testOptionData: {
        select62173: [{
          label: '01',
          value: 1
        }, {
          label: '22',
          value: 2
        }, {
          label: '333',
          value: 3
        }],
        select001: [{
          label: '辣椒',
          value: 1
        }, {
          label: '菠萝',
          value: 2
        }, {
          label: '丑橘子',
          value: 3
        }]
      },
      id: 0,
      formCopyJson: ''
    };
  },
  computed: {
    formJson: function formJson() {
      return {
        // widgetList: this.designer.widgetList,
        // formConfig: this.designer.formConfig

        widgetList: deepClone(this.designer.widgetList),
        formConfig: deepClone(this.designer.formConfig)
      };
    },
    undoDisabled: function undoDisabled() {
      return !this.designer.undoEnabled();
    },
    redoDisabled: function redoDisabled() {
      return !this.designer.redoEnabled();
    },
    layoutType: function layoutType() {
      return this.designer.getLayoutType();
    },
    designerDsv: function designerDsv() {
      return this.globalDsv;
    }
  },
  watch: {
    'designer.widgetList': {
      deep: true,
      handler: function handler(val) {
        //console.log('test-----', val)
        //this.refreshNodeTree()
      }
    }
  },
  created: function created() {
    this.id = this.$route.query.id;
    this.designer.initHistoryData();
    this.formInfo();
  },
  mounted: function mounted() {
    var _this = this;
    var maxTBWidth = this.designerConfig.toolbarMaxWidth || 420;
    var minTBWidth = this.designerConfig.toolbarMinWidth || 300;
    var newTBWidth = window.innerWidth - 260 - 300 - 320 - 80;
    this.toolbarWidth = newTBWidth >= maxTBWidth ? maxTBWidth : newTBWidth <= minTBWidth ? minTBWidth : newTBWidth;
    addWindowResizeHandler(function () {
      _this.$nextTick(function () {
        var newTBWidth2 = window.innerWidth - 260 - 300 - 320 - 80;
        _this.toolbarWidth = newTBWidth2 >= maxTBWidth ? maxTBWidth : newTBWidth2 <= minTBWidth ? minTBWidth : newTBWidth2;
      });
    });
  },
  methods: {
    onlyReadMode: function onlyReadMode() {
      this.$refs.preForm.setReadMode(!this.$refs.preForm.$data.readModeFlag);
    },
    formInfo: function formInfo() {
      var _this2 = this;
      _formInfo(this.id).then(function (res) {
        if (res.data.global_options) {
          _this2.importTemplate.formConfig = res.data.global_options;
          _this2.designer.selectNames = res.data.fields;
        }
        _this2.importTemplate.widgetList = res.data.options || [];
        _this2.doJsonImport();
      });
    },
    showToolButton: function showToolButton(configName) {
      if (this.designerConfig[configName] === undefined) {
        return true;
      }
      return !!this.designerConfig[configName];
    },
    doJsonImport: function doJsonImport() {
      try {
        var importObj = this.importTemplate;
        this.designer.loadFormJson(importObj);
        this.designer.emitHistoryChange();
        this.designer.emitEvent('form-json-imported', []);
      } catch (ex) {
        this.$message.error(ex);
      }
    },
    buildTreeNodeOfWidget: function buildTreeNodeOfWidget(widget, treeNode) {
      var _this3 = this;
      var curNode = {
        id: widget.id,
        label: widget.options.label || widget.type
        //selectable: true,
      };
      treeNode.push(curNode);
      if (widget.category === undefined) {
        return;
      }
      curNode.children = [];
      if (widget.type === 'grid') {
        widget.cols.map(function (col) {
          var colNode = {
            id: col.id,
            label: col.options.name || widget.type,
            children: []
          };
          curNode.children.push(colNode);
          col.widgetList.map(function (wChild) {
            _this3.buildTreeNodeOfWidget(wChild, colNode.children);
          });
        });
      } else if (widget.type === 'table') {
        //TODO: 需要考虑合并单元格！！
        widget.rows.map(function (row) {
          var rowNode = {
            id: row.id,
            label: 'table-row',
            selectable: false,
            children: []
          };
          curNode.children.push(rowNode);
          row.cols.map(function (cell) {
            if (!!cell.merged) {
              //跳过合并单元格！！
              return;
            }
            var rowChildren = rowNode.children;
            var cellNode = {
              id: cell.id,
              label: 'table-cell',
              children: []
            };
            rowChildren.push(cellNode);
            cell.widgetList.map(function (wChild) {
              _this3.buildTreeNodeOfWidget(wChild, cellNode.children);
            });
          });
        });
      } else if (widget.type === 'tab') {
        widget.tabs.map(function (tab) {
          var tabNode = {
            id: tab.id,
            label: tab.options.name || widget.type,
            selectable: false,
            children: []
          };
          curNode.children.push(tabNode);
          tab.widgetList.map(function (wChild) {
            _this3.buildTreeNodeOfWidget(wChild, tabNode.children);
          });
        });
      } else if (widget.type === 'sub-form') {
        widget.widgetList.map(function (wChild) {
          _this3.buildTreeNodeOfWidget(wChild, curNode.children);
        });
      } else if (widget.category === 'container') {
        //自定义容器
        widget.widgetList.map(function (wChild) {
          _this3.buildTreeNodeOfWidget(wChild, curNode.children);
        });
      }
    },
    refreshNodeTree: function refreshNodeTree() {
      var _this4 = this;
      this.nodeTreeData.length = 0;
      this.designer.widgetList.forEach(function (wItem) {
        _this4.buildTreeNodeOfWidget(wItem, _this4.nodeTreeData);
      });
    },
    undoHistory: function undoHistory() {
      this.designer.undoHistoryStep();
    },
    redoHistory: function redoHistory() {
      this.designer.redoHistoryStep();
    },
    changeLayoutType: function changeLayoutType(newType) {
      this.designer.changeLayoutType(newType);
    },
    clearFormWidget: function clearFormWidget() {
      this.designer.clearDesigner();
      this.designer.clearWidgetRefList();
    },
    previewForm: function previewForm() {
      this.showPreviewDialogFlag = true;
    },
    saveAsFile: function saveAsFile(fileContent, defaultFileName) {
      var _this5 = this;
      this.$prompt('文件名：', '保存为文件', {
        inputValue: defaultFileName,
        closeOnClickModal: false,
        inputPlaceholder: '请输入文件名'
      }).then(function (_ref) {
        var value = _ref.value;
        if (!value) {
          value = defaultFileName;
        }
        if (getQueryParam('vscode') == 1) {
          _this5.vsSaveFile(value, fileContent);
          return;
        }
        var fileBlob = new Blob([fileContent], {
          type: 'text/plain;charset=utf-8'
        });
        saveAs(fileBlob, value);
      }).catch(function () {
        //
      });
    },
    vsSaveFile: function vsSaveFile(fileName, fileContent) {
      var msgObj = {
        cmd: 'writeFile',
        data: {
          fileName: fileName,
          code: fileContent
        }
      };
      window.parent.postMessage(msgObj, '*');
    },
    importJson: function importJson() {
      this.importTemplate = JSON.stringify(this.designer.getImportTemplate(), null, '  ');
      this.showImportJsonDialogFlag = true;
    },
    exportJson: function exportJson() {
      var widgetList = deepClone(this.designer.widgetList);
      var formConfig = deepClone(this.designer.formConfig);
      this.jsonContent = JSON.stringify({
        widgetList: widgetList,
        formConfig: formConfig
      }, null, '  ');
      this.jsonRawContent = JSON.stringify({
        widgetList: widgetList,
        formConfig: formConfig
      });
      // this.showExportJsonDialogFlag = true
      // 请求数据

      var saveData = {
        options: this.designer.widgetList,
        fields: this.designer.selectNames,
        global_options: this.designer.formConfig
      };
      formCrudSave(this.id, saveData).then(function (res) {});
    },
    copyFormJson: function copyFormJson(e) {
      copyToClipboard(this.jsonRawContent, e, this.$message, '复制JSON成功', '复制JSON失败');
    },
    saveFormJson: function saveFormJson() {
      this.saveAsFile(this.jsonContent, "vform".concat(generateId(), ".json"));
    },
    copyVueCode: function copyVueCode(e) {
      copyToClipboard(this.vueCode, e, this.$message, this.i18nt('designer.hint.copyVueCodeSuccess'), this.i18nt('designer.hint.copyVueCodeFail'));
    },
    copyHtmlCode: function copyHtmlCode(e) {
      copyToClipboard(this.htmlCode, e, this.$message, this.i18nt('designer.hint.copyHtmlCodeSuccess'), this.i18nt('designer.hint.copyHtmlCodeFail'));
    },
    saveVueCode: function saveVueCode() {
      this.saveAsFile(this.vueCode, "vform".concat(generateId(), ".vue"));
    },
    saveHtmlCode: function saveHtmlCode() {
      this.saveAsFile(this.htmlCode, "vform".concat(generateId(), ".html"));
    },
    copyV3SFC: function copyV3SFC(e) {
      copyToClipboard(this.sfcCodeV3, e, this.$message, this.i18nt('designer.hint.copySFCSuccess'), this.i18nt('designer.hint.copySFCFail'));
    },
    saveV2SFC: function saveV2SFC() {
      this.saveAsFile(this.sfcCode, "vformV2-".concat(generateId(), ".vue"));
    },
    saveV3SFC: function saveV3SFC() {
      this.saveAsFile(this.sfcCodeV3, "vformV3-".concat(generateId(), ".vue"));
    },
    getFormData: function getFormData() {
      var _this6 = this;
      this.$refs['preForm'].getFormData(false).then(function (formData) {
        _this6.formDataJson = JSON.stringify(formData, null, '  ');
        _this6.formDataRawJson = JSON.stringify(formData);
        var formCopyJson = JSON.parse(JSON.stringify(formData));
        Object.keys(formCopyJson).forEach(function (key) {
          if (key.includes('@')) {
            var newKey = key.replace('@', '.');
            formCopyJson[newKey] = formCopyJson[key];
            delete formCopyJson[key];
          }
        });
        _this6.formCopyJson = JSON.stringify(formCopyJson, null, '  ');
        _this6.showFormDataDialogFlag = true;
      }).catch(function (error) {
        _this6.$message.error(error);
      });
    },
    copyFormDataJson: function copyFormDataJson(e) {
      copyToClipboard(this.formDataRawJson, e, this.$message, this.i18nt('designer.hint.copyJsonSuccess'), this.i18nt('designer.hint.copyJsonFail'));
    },
    saveFormData: function saveFormData() {
      this.saveAsFile(this.htmlCode, "formData".concat(generateId(), ".json"));
    },
    resetForm: function resetForm() {
      this.$refs['preForm'].resetForm();
    },
    setFormDisabled: function setFormDisabled() {
      this.$refs['preForm'].disableForm();
    },
    setFormEnabled: function setFormEnabled() {
      if (this.$refs.preForm.$data.readModeFlag) this.$refs.preForm.setReadMode(!this.$refs.preForm.$data.readModeFlag);
      this.$refs['preForm'].enableForm();
    },
    handleFormChange: function handleFormChange(fieldName, newValue, oldValue, formModel) {
      /*
        console.log('---formChange start---')
        console.log('fieldName', fieldName)
        console.log('newValue', newValue)
        console.log('oldValue', oldValue)
        console.log('formModel', formModel)
        console.log('---formChange end---')
        */
    },
    testOnAppendButtonClick: function testOnAppendButtonClick(clickedWidget) {
      console.log('test', clickedWidget);
    },
    testOnButtonClick: function testOnButtonClick(button) {
      console.log('test', button);
    },
    findWidgetById: function findWidgetById(wId) {
      var foundW = null;
      traverseAllWidgets(this.designer.widgetList, function (w) {
        if (w.id === wId) {
          foundW = w;
        }
      });
      return foundW;
    },
    onNodeTreeClick: function onNodeTreeClick(nodeData, node, nodeEl) {
      //console.log('test', JSON.stringify(nodeData))

      if (nodeData.selectable !== undefined && !nodeData.selectable) {
        this.$message.info(this.i18nt('designer.hint.currentNodeCannotBeSelected'));
      } else {
        var selectedId = nodeData.id;
        var foundW = this.findWidgetById(selectedId);
        if (!!foundW) {
          this.designer.setSelected(foundW);
        }
      }
    }
  }
};